export default __webpack_public_path__ + "static/media/NECO.39c6c681.pdf";